export const LIST_DIALPAD_CALLCENTERS = 'LIST_DIALPAD_CALLCENTERS';
export const CALLCENTERS = 'callcenters';
